import { Scene } from "phaser";
import { GButton } from "../gameobjects/GButton";
import { Slider } from "../gameobjects/Slider";
import { PickedNumbers } from "../gameobjects/PickedNumbers";


const COLOR_MAIN = 0x4e342e;
const COLOR_LIGHT = 0x7b5e57;
const COLOR_DARK = 0x212121;


export class BuyTicketScene extends Scene {
    
    constructor() {
        super("BuyTicketScene");
    }

    init(data) {
        // this.cameras.main.fadeIn(1000, 0, 0, 0);
        this.background = "#ccc"
        //data.rt.saveTexture('snapshotTexture');
    }

    // Function to be called when the scene resumes
    onResume(that) {
        //console.log("resume")

        this.currentCatItem = this.registry.get('cart_items')
        //console.log("currentCatItem", this.currentCatItem);
        this.noTicketsText.setVisible(false);

        this.panel.setVisible(true);
        this.boxGraphics.setVisible(false)
        
        this.updateTicketList()
    }

    create() {

        //console.log("Create: BuyTicketScene")
        // Example function on the scene that you want to call
        this.onSpriteClick = function(index) {
            console.log('Function on the scene triggered from the container', index);
            this.currentCatItem.splice(index, 1);
            this.currentCatItem = this.registry.get('cart_items')
            this.registry.set('cart_items', this.currentCatItem);
            
            // Add any logic you want to execute when the sprite is clicked
            this.updateTicketList();
        };  

        const containerY = (62  +16 + 28 +24) *2;
        this.containerY = containerY;
        const HeaderY = (62 +16 + 24 ) *2
        // Event listener for when the scene resumes
        this.events.on('resume', this.onResume, this);

            
        this.numberGrid = [];
        this.title = this.add.text(this.scale.width/2, HeaderY , `BUY TICKETS`,  { fontFamily: 'Oswald', fontSize: 48, color: '#ffffff' }).setOrigin(0.5);
        this.title.setFontStyle('700')

        const ButtonBack = new GButton(this,this.scale.width/2-330, HeaderY, {
            texturePack: "pack", 
            idleTexture: 'arrow back_ios.png',
            clickedTexture: 'arrow back_ios.png',
            disabledTexture: 'arrow back_ios.png',
            onClick: () => {
                //console.log('Button ButtonBack!');
                this.scene.start("MenuScene");
             }
        });
    
        ButtonBack.setScale(0.85);

    this.currentDrawInfo = this.registry.get('currentDraw');


    this.TicketsHeader = this.add.nineslice(this.scale.width/2,  containerY + 52, 'pack', 'header-main.png', 343*2, 104, 32, 32);
    //this.TicketsHeader.setScale(0.75);

    this.DrawDate = this.unixToDate( this.registry.get('drawdate'));

    this.drawDateText = this.add.text(this.scale.width/2-319,  containerY +52, `DRAW DATE` ,  { fontFamily: 'Oswald', fontSize: 26, color: '#ffffff' }).setOrigin(0,0.5);
    this.drawDateText.setFontStyle('700')

    //console.log("this.drawDateText.bounds", this.drawDateText);

    this.drawDateDate = this.add.text(this.drawDateText.x + this.drawDateText.width + 16,  containerY +50, this.DrawDate ,  { fontFamily: 'Oswald', fontSize: 30, color: '#ffffff' }).setOrigin(0,0.5);
    this.drawDateDate.setFontStyle('700')


    this.drawNumber = this.add.text(this.scale.width/2+319,  containerY + 50, this.currentDrawInfo.draw_date_id ,  { fontFamily: 'Oswald', fontSize: 34, color: '#ffffff' }).setOrigin(1,0.5);
    this.drawNumber.setFontStyle('700')

    this.drawNumberText = this.add.text(this.drawNumber.x - this.drawNumber.width - 16,  containerY +52, `DRAW NO.` ,  { fontFamily: 'Oswald', fontSize: 26, color: '#ffffff' }).setOrigin(1,0.5);
    this.drawNumberText.setFontStyle('700')

    



    this.boxHight = this.scale.height/2;

    this.noTicketsText = this.add.text(this.scale.width/2, containerY + 104 + 93, `NO TICKETS YET...` ,  { fontFamily: 'Oswald', fontSize: 26, color: '#ffffff' }).setOrigin(0.5);
    this.noTicketsText.setFontStyle('700')
    this.noTicketsText.setVisible(true);

    this.currentCatItem = this.registry.get('cart_items')


    if(this.currentCatItem.length == 0){
        this.boxHight = 186;
        this.noTicketsText.setVisible(true);
    }

    this.boxGraphics = this.add.graphics();

    this.boxGraphics.fillStyle(0x212121, 1);

    // //  Using an object to define a different radius per corner
    this.boxGraphics.fillRoundedRect(this.scale.width/2-342, containerY +104, 343*2, this.boxHight, { tl: 0, tr: 0, bl: 32, br: 32 });

    

        const ButtonManualPick = new GButton( this, this.scale.width/2 - 180, this.scale.height -240, {
            texturePack: "pack", 
            idleTexture: 'Button - Secondary - Default.png',
            clickedTexture: 'Button - Secondary - Clicked.png',
            disabledTexture: 'Button - Secondary - Disabled.png',
            text: {
                value:'ADD MANUAL PICK',
                style:  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }
            },
            onClick: () => {
                //console.log('Button ButtonManualPick!');
                const lottery = this.registry.get('lottery');
                this.scene.start("ManualPickScene", {
                    min: lottery.min_selected_number,
                    max: lottery.max_selected_number,
                    ticketPrice: +lottery.ticket_price,
                    minNumber: lottery.min_number,
                    maxNumber: lottery.max_number,
                });
             }
        });
    
        

        const ButtonQuickPick = new GButton( this,this.scale.width/2 + 180, this.scale.height -240, {
            texturePack: "pack", 
            idleTexture: 'Button - Secondary - Default.png',
            clickedTexture: 'Button - Secondary - Clicked.png',
            disabledTexture: 'Button - Secondary - Disabled.png',
            text: {
                value:'ADD QUICK PICK',
                style:  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }
            },
            onClick: () => {
                //console.log('Button ButtonQuickPick!');
                //this.scene.pause("BuyTicketScene")
                const lottery = this.registry.get('lottery');
                this.scene.launch("QuickPickScene", {
                    min: lottery.min_selected_number,
                    max: lottery.max_selected_number,
                    ticketPrice: +lottery.ticket_price,
                    minNumber: lottery.min_number,
                    maxNumber: lottery.max_number,
                })
             }
        });
    
        
        


        this.mySlider = new Slider(this, this.scale.width/2,this.scale.height - 106,686,104);
        this.mySlider.setDisabled();

        //this.registry.events.on('changedata', this.updateSlider);

        // console.log("this.currentCatItem", this.currentCatItem)
        // if(this.currentCatItem.length > 0){
        //     // let sum = 0
        //     // for (let index = 0; index < this.currentCatItem.length; index++) {
        //     //     const element = this.currentCatItem[index];
        //     //    sum += +element.totalAmount
                
        //     // }
        //     // this.mySlider.setValue(sum);

        //     // this.numberGrid = new PickedNumbers(this, 100 , 320+ 50 * index, this.currentCatItem[index].selectedNumbers);
        //     this.updateTicketList();
        // }
        
        

        

        // this.cameras.main.setBackgroundColor('rgba(0,0,0,0.8)');

        // const renderTexture = this.add.renderTexture(0, 0, this.scale.width, this.scale.height);
        
        // // Draw the captured snapshot onto the RenderTexture
        // renderTexture.draw([this.scene.get('MainScene').children, 
        // ], 0, 0);
        // renderTexture.saveTexture('snapshotTexture');
    
        // // Now you can use this texture to create a sprite
        // const snapshotSprite = this.add.image(this.scale.width/2, this.scale.height/2, 'snapshotTexture');
    
        // // Optional: Scale, move, or modify the sprite as needed
        // snapshotSprite.setOrigin(0.5);
        // snapshotSprite.preFX.addBlur();

        const containerWidth = this.scale.width/2
        const containerHeight = 394*2
        const cornerRadius = 32;
        // Create a scrollable panel
        // const scrollablePanel = this.rexUI.add.scrollablePanel({
        //     x: 400,
        //     y: 300,
        //     width: containerWidth,
        //     height: containerHeight,
        
        //     scrollMode: 0, // Vertical scrolling
        
        //     background: this.add.graphics()
        //     .fillStyle(0xffffff, 1)
        //     .fillRoundedRect(0, 0, containerWidth, containerHeight, cornerRadius),
        
        //     panel: {
        //     child: this.createItemList(this),
        //     mask: { padding: 1 },
        //     },
        
        //     mouseWheelScroller: { focus: false },
        
        //     slider: {
        //     track: this.add.graphics()
        //         .fillStyle(0x888888)
        //         .fillRoundedRect(0, 0, 20, containerHeight, 10),
        //     thumb: this.add.graphics()
        //         .fillStyle(0xcccccc)
        //         .fillCircle(0, 0, 10),
        //     },
        
        //     space: {
        //     left: 10,
        //     right: 10,
        //     top: 10,
        //     bottom: 10,
        //     panel: 10,
        //     },
        // }).layout();

        //this.ticketContainer = this.add.container()

        this.panel = this.rexUI.add.scrollablePanel({
            x: this.scale.width/2, y: containerY +104,
            width:  343*2,
            height: 300,
            originY: 0,

            scrollMode: 0,
            background: this.rexUI.add.roundRectangle({
                color: COLOR_DARK,
                // strokeColor:"#FFFFF",
                radius: { tl: 0, tr: 0, bl: 32, br: 32 }
            }),
            panel: {
                child: this.CreatePanel(this),//this.CreatePanel(this)
                //mask: { padding: 30, },
            },
            space: { left: 20, right: 20, top: 40, bottom: 20, panel: 10}
        })
            .layout()


        // Add new child
       
        // Layout scrollable panel again
        this.panel.layout();
        this.noTicketsText.setToTop()
        
        this.panel.setVisible(false);

        
        if(this.currentCatItem.length > 0){


            // this.panel.setSize(343*2, containerHeight); // Update height
            // this.panel.height = containerHeight; // Update height
            this.panel.setMinSize(this.panel.width, containerHeight).layout();
            this.panel.layout(); // Recalculate layout to apply the new size

            this.noTicketsText.setVisible(false);
            this.panel.setVisible(true);
            this.boxGraphics.setVisible(false)
            // let sum = 0
            // for (let index = 0; index < this.currentCatItem.length; index++) {
            //     const element = this.currentCatItem[index];
            //    sum += +element.totalAmount
                
            // }
            // this.mySlider.setValue(sum);

            // this.numberGrid = new PickedNumbers(this, 100 , 320+ 50 * index, this.currentCatItem[index].selectedNumbers);
            this.updateTicketList();
        }
        

    
                        
    }

    CreatePanel(scene) {
        var panel = scene.rexUI.add.sizer({
            orientation: 'y',
            space: { top: 0, bottom: 20 }
        })
    
        // var contentList = ['AAAA', 'BBBB', 'CCCC', 'DDDDD', 'EEEEE', 'FFFFF'];
        // for (var i = 0, cnt = contentList.length; i < cnt; i++) {
        //     panel
        //         .add(
        //             this.CreatePaper(scene,
        //                 contentList[i],
        //                 scene.rexUI.add.roundRectangle(0, 0, 200, 400, 20, COLOR_MAIN))
        //         )
        // }
    
        return panel;
    }
    
    // CreatePaper(scene, background) {
    //     return scene.rexUI.add.label({
    //         orientation: 'x',
    //         width: background.displayWidth,
    //         height: background.displayHeight,
    
    //         background: background,
    //         text: scene.add.text(0, 0, content),
    
    //         align: 'center'
    //     })
    // }

    // createItemList(scene){
    //     const itemSpacing = 10
    //     const totalItems = 10
    //     const containerWidth = scene.scale.width/2
    //     const itemHeight = 30
    //     const sizer = scene.rexUI.add.fixWidthSizer({
    //         space: { item: itemSpacing },
    //         align: 'left',
    //       });

    //       for (let i = 0; i < totalItems; i++) {
    //         const itemBackground = scene.add.graphics()
    //           .fillStyle(0xdddddd, 1)
    //           .fillRect(0, 0, containerWidth - 40, itemHeight);
        
    //         const itemText = scene.add.text(10, 10, `Item ${i + 1}`, { fontSize: '24px', color: '#000' });
        
    //         const itemContainer = scene.add.container(0, 0, [itemBackground, itemText]);
        
    //         sizer.add(itemContainer, 0, 'left', 0, true);
    //       }

    //     return sizer;
    // }

    updateSlider (parent, key,data)
    {
        if (key === 'cart_amount') {
            //console.log(data)
           
        }
     
        if(key === 'cart_items'){

            
            const gameScene = data.scene.get('BuyTicketScene');
            const sceneState = data.scene.manager.getState('BuyTicketScene');
            if(sceneState ) {

                this.currentCatItem = this.registry.get('cart_items')
            
                this.noTicketsText.setVisible(false);
    
                this.updateTicketList()

            }
            
        }
    }

    updateTicketList(){

        var sum = 0
        try {
            this.panel.getElement('panel').removeAll(true);    
        } catch (error) {
            console.log(error)
        }

        var fullHeight = 0       
        for (let index = 0; index < this.currentCatItem.length; index++) {
           const element = this.currentCatItem[index];
           sum += +element.totalAmount
           
           var lastBoxY = 360;
           this.currentBound = 20
       
           //92, lastBoxY
           this.numberGrid[index] = new PickedNumbers(this, 0 , 0, {numbersArray: this.currentCatItem[index], ticketNumber: index });
           //this.ticketContainer.add(this.numberGrid[index]);
           //if(index > 0){
            const bounds = this.numberGrid[index].getBounds()
            
            lastBoxY = bounds.height + bounds.y + 50

            fullHeight += bounds.height + 100
            if(fullHeight > 394*2){
                fullHeight = 394*2
            }
            
            this.currentBound = bounds.height;
            //}
           this.panel
           .getElement('panel')
           .add(
                this.numberGrid[index],
                {
                    //space: { item: this.currentBound, left: 32, top: 20, bottom: 20 },
                    proportion: 0,
                    align: 'left',
                    padding: {left: 0, right: 0, top: 0 , bottom: this.currentBound + 36},
                    expand: false,
                    //key: undefined,
                    //index: undefined,
                    // minWidth: undefined,
                    // minHeight: undefined,
                    fitRatio: 0,  // true
                    offsetX: 0,
                    //offsetY: lastBoxY,
                    // offsetOriginX: 0,
                    // offsetOriginY: 0,
                }
           );
           this.panel
           .getElement('panel')

           
        }

        this.panel
        .getElement('panel')
        .addSpace().layout()

        // this.panel.setMinSize(600, fullHeight).layout();


        if(this.currentCatItem.length == 0){
            this.noTicketsText.setVisible(true);
            this.panel.setVisible(false);

            this.boxHight = 186;
            this.boxGraphics.clear(); // Clear the graphics object
            this.boxGraphics.fillStyle(0x212121, 1);
            this.boxGraphics.fillRoundedRect(this.scale.width/2-342, this.containerY +104, 343*2, this.boxHight, { tl: 0, tr: 0, bl: 32, br: 32 });
            this.boxGraphics.setVisible(true)
        }

        this.panel.layout()

        this.mySlider.setValue(sum);

    }

    unixToDate(unixTimestamp) {
        // Convert Unix timestamp to milliseconds
        const date = new Date(unixTimestamp * 1000);
    
        // Extract the day, month, and year
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = String(date.getFullYear()).slice(-2); // Get last two digits of the year
    
        // Return formatted date in dd.mm.yy format
        return `${day}.${month}.${year}`;
    }

}